import { createSlice } from "@reduxjs/toolkit"

export const searchResultsSlice = createSlice({
	name: "search_results",
	initialState: {
		results: "",
		errors: [],
	},

	reducers: {
		getSearchResults: (state, action) => {
			state.results = action.payload
		},
		getSearchResultsSuccess: (state, action) => {
			state.results = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})

export const { getSearchResults, getSearchResultsSuccess, getErrors } = searchResultsSlice.actions

export default searchResultsSlice.reducer
